import { render, staticRenderFns } from "./ModalTablePaginationServerMultiple.vue?vue&type=template&id=44563dc4&"
import script from "./ModalTablePaginationServerMultiple.vue?vue&type=script&lang=js&"
export * from "./ModalTablePaginationServerMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports